import ProfileSettings from "@/components/ProfileSettings";
export default function MerchantProfile() {
  return <ProfileSettings index="06" showCompany />;
}
